<bn-loading-overlay></bn-loading-overlay>

<div class="table-responsive" *ngIf="taxas && taxas.length">
    <div class="float-start letra-miuda">apuração realizada em: {{ taxas[0].dataApuracao }}</div>
    <table class="table table-hover">
        <thead>
        <tr>
            <th>Agente Financeiro</th>
            <th>Janela de Apuração</th>
            <th class="titulo-moeda">Taxa Média Anual (%)</th>
            <th class="titulo-moeda">Taxa Máxima Anual (%)</th>
            <th class="">Fator(%)</th>
        <tr>
        </thead>
        <tbody>
        <tr *ngFor="let taxa of taxas" [ngClass]="{'taxa-maior-que-maxima': verificarTaxaMediaMaiorTaxaMaxima(taxa)}">
            <td>
                {{taxa.agente.sigla}}
            </td>
            <td>
                {{encontrarIdJanelaTaxaMediaMaxima(taxa.ideJanelaApuracao) }}
            </td>
            <td class="moeda">
                {{taxa.taxaJurosMediaAgente | number:'1.9-9'}}
            </td> 
            <td class="moeda">
                {{taxa.taxaJurosMaximaAgente | number:'1.9-9'}}
            </td> 
            <td>
                {{taxa.fator}}
            </td>
        </tr>
        </tbody>
    </table>
</div>
<div *ngIf="taxas && !taxas.length && !agenteFinanceiro "><p class="obs-erro">Não existem taxas médias apuradas para os filtros especificados.</p></div>
<div *ngIf="taxas && !taxas.length && agenteFinanceiro"><p class="obs-erro">Não há apuração de taxa de juros média realizada para este agente financeiro com os filtros especificados.</p></div>